@if (creatorInfo) {
  <app-modal modalId="creatorInfo" [verticallyCentered]="true">
    <div class="modal-body">
      <div class="guestModal py-3 px-3 gilroy position-relative">
        <h6 class="text-center">Enter Creator Info</h6>
        <fa-icon
          [icon]="faTimes"
          (click)="helper.showModal(false, 'creatorInfo')"
          class="position-absolute top-0 end-0 cursor"
        ></fa-icon>
        <div class="row">
          <div class="col-lg-12 text-center">
            <small
              >Please provide the creator's name and any social media links to
              submit your request.</small
            >
          </div>
          <div class="col-lg-12 mt-3">
            <app-input
              type="text"
              toolTip="Please enter creator Full Name, for example, 'John Doe'"
              [icon]="faUser"
              [form]="InfoForm"
              control="creatorName"
              label="Creator Full Name"
              placeholder="Enter creator Full Name"
              AlphabetsOnly
            ></app-input>
          </div>
          <div class="col-lg-12 mt-3">
            <app-input
              type="text"
              toolTip="Paste the link of creator any social media account"
              [icon]="faLink"
              [form]="InfoForm"
              control="socialLink"
              label="Social Link"
              placeholder="Paste the link of creator any social media account"
            ></app-input>
          </div>
          <div class="col-lg-12 text-center mt-3">
            <button
              type="submit"
              class="btnPrimary w-100 gilroy-b agreeSmall py-2 rounded-2"
              [disabled]="InfoForm.invalid"
              (click)="addCreator()"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal>
}
